import { createAction } from 'redux-act';
// add Report action
const salaryReportRequest = createAction('SALARY_REPORT_REQUEST', data => data);
const salaryReportSuccess = createAction('SALARY_REPORT_SUCCESS', data => data);
const salaryReportError = createAction('SALARY_REPORT_ERROR');

// clear existing Report action
const handleClearReportStore = createAction('HANDLE_CLEAR_REPORT_STORE',data => data);
// const toastMsgAction = createAction('SUCCESS', data=> data);

export default {
    salaryReportRequest,
    salaryReportSuccess,
    salaryReportError,

    handleClearReportStore,
}